import {schema} from 'normalizr'
import {articleSchema} from './article'
import {askSchema} from './ask'
import {channelSchema} from './channel'
import {groupSchema, organizationSchema} from './organization'
import {pollSchema} from './poll'
import {postSchema} from './post'
import {userSchema} from './user'
import {widgetSchema} from './widget'
import {godwordsSchema} from "../godwords";
import {userCheckinSchema} from "../event";

export const feedContainerSchema = new schema.Union(
    {
        user: userSchema,
        channel: channelSchema,
        organization: organizationSchema,
        group: groupSchema,
    },
    '_type'
)

export const announcementSchema = new schema.Entity(
    'announcements',
    {},
    {
        idAttribute: 'id',
    }
)

export const feedContentSchema = new schema.Union(
    {
        post: postSchema,
        ask: askSchema,
        poll_question: pollSchema,
        article: articleSchema,
        announcement: announcementSchema,
        widget: widgetSchema,
    },
    '_type'
)

export const getContentSchema = (type) => {
    switch (type) {
        case "post":
            return postSchema;
        case "ask":
            return askSchema;
        case "poll_question":
            return pollSchema;
        case "article":
            return articleSchema;
        case "god_word":
            return godwordsSchema;
        case "user_checkin":
            return userCheckinSchema;
        case "announcement":
            return announcementSchema;
        default:
    }
    return postSchema;
}

export const feedSchema = new schema.Entity(
    'feeds',
    {
        container: feedContainerSchema,
        content: feedContentSchema,
    },
    {
        idAttribute: 'id',
    }
)

export const recommendationUsersFeedSchema = new schema.Entity(
    'feeds',
    {
        content: [userSchema],
    },
    {
        idAttribute: 'id',
    }
)
export const recommendationChannelsFeedSchema = new schema.Entity(
    'feeds',
    {
        content: [channelSchema],
    },
    {
        idAttribute: 'id',
    }
)


export const homeFeed = new schema.Union(
    {
        feed: feedSchema,
        'recommendation-channels': recommendationChannelsFeedSchema,
        'recommendation-users': recommendationUsersFeedSchema
    },
    (value) => {
        switch (value.action) {
            case 'recommendation-channels':
                return 'recommendation-channels'
            case 'recommendation-users':
                return 'recommendation-users'
            default:
                return 'feed'
        }
    }
)
